module.exports = __webpack_public_path__ + "static/media/undraw_online_test_gba7 (1).d51f1566.svg";